import axios from "axios";

export function fetchTemplate(payload) {
  return new Promise((resolve, reject) => {
    axios.get(`/serialnumber/api/v1/product-ui-template/${payload.id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}
